<!--
 * @Description: 提现记录
-->
<template>
  <scroll-layout>
    <template #header>
      <ykc-search
        ref="YkcSearch"
        :data="searchData"
        :searchForm="searchParams"
        confirmBtnLabel="确认"
        clearBtnLabel="清空"
        @click="handleSearchConfirm"
        @clean="handleSearchClean"></ykc-search>
    </template>
    <div class="record-page">
      <ykc-table ref="YkcTable" :data="tableData" :columns="tableColumns" title="提现记录">
        <template #headerButtons>
          <ykc-button type="plain" @click="doExportFile">导出</ykc-button>
        </template>
        <ykc-pagination
          slot="pagination"
          ref="YkcPagination"
          direct="flex-end"
          :total="pageInfo.total"
          :current-page.sync="pageInfo.pageIndex"
          @current-change="handlePaginationCurrentChange"
          :page-size.sync="pageInfo.pageSize"
          @size-change="handlePaginationSizeChange"></ykc-pagination>
      </ykc-table>
    </div>

    <ykc-operation-dialog
      title="失败重试"
      confirm-btn-txt="确认提交"
      :confirm-loading="confirmLoading"
      :before-confirm="handleConfirmRetry"
      :show.sync="retryDialogVisible">
      <div slot="content" class="request-dialog-content">
        <div class="request-item">
          <span class="request-label">编码：</span>
          <span class="request-value">{{ currentRow.withdrawNo }}</span>
        </div>
        <div class="request-item">
          <span class="request-label">交易金额：</span>
          <span class="request-value">{{ currentRow.tradeAmount }}元</span>
        </div>
      </div>
    </ykc-operation-dialog>

    <clearing-log-dialog
      :show.sync="logDialogVisible"
      :type="3"
      :client-sn="logClientSn"></clearing-log-dialog>
  </scroll-layout>
</template>

<script>
  import YkcOperationDialog from '@/components/ykc-ui/operation-dialog';
  import ClearingLogDialog from './components/ClearingLogDialog.vue';
  import { withdrawRecord } from '@/service/apis';
  import { offlineExport } from '@/utils';

  export default {
    name: 'WithdrawRecord',
    components: {
      YkcOperationDialog,
      ClearingLogDialog,
    },
    data() {
      return {
        tableData: [],
        pageInfo: {
          total: 0,
          pageIndex: 1,
          pageSize: 10,
        },
        searchParams: {
          withdrawNo: '',
          operatorId: '',
          withdrawType: '',
          tradeStatus: '',
          createdDate: [],
        },
        withdrawTypeOptions: [
          { id: 1, name: '自营提现' },
          { id: 2, name: '加盟提现' },
          { id: 3, name: '平台子账户提现' },
        ],
        operatorList: [],
        tradeStatusOptions: [
          { id: 1, name: '成功' },
          { id: 2, name: '失败' },
          { id: 3, name: '处理中' },
        ],
        tableColumns: [
          { label: '提现记录编码', prop: 'withdrawNo', minWidth: '220px' },
          { label: '收款商户', prop: 'operatorName', minWidth: '140px' },
          { label: '提现类型', prop: 'withdrawTypeName', minWidth: '100px' },
          { label: '银行卡号', prop: 'bankNo', minWidth: '160px' },
          { label: '交易金额（元）', prop: 'tradeAmount', minWidth: '130px' },
          { label: '交易状态', prop: 'tradeStatusName', minWidth: '100px' },
          { label: '提现业务ID', prop: 'qztId', minWidth: '150px' },
          { label: '银行提现单号', prop: 'tradeNo', minWidth: '180px' },
          { label: '提现银行', prop: 'cardBankName', minWidth: '140px' },
          { label: '完成时间', prop: 'finishTime', minWidth: '160px' },
          {
            label: '创建人',
            prop: 'createdPersonName',
            minWidth: '100px',
            scopedSlots: {
              default: ({ row }) => {
                return <span>{row.createdPerson === 0 ? '系统' : row.createdPersonName}</span>;
              },
            },
          },
          { label: '创建时间', prop: 'createdTime', minWidth: '170px' },
          { label: '最后更新人', prop: 'lastUpdatePersonName', minWidth: '100px' },
          { label: '最后更新时间', prop: 'lastUpdateTime', minWidth: '170px' },
          { label: '失败原因', prop: 'failReason', minWidth: '150px' },
          {
            label: '操作',
            prop: 'operate',
            minWidth: '165px',
            fixed: 'right',
            scopedSlots: {
              default: ({ row }) => {
                return (
                  <div class="operate-btns">
                    <ykc-button type="text" onClick={() => this.handleShowLog(row)}>
                      查看日志
                    </ykc-button>
                    {row.tradeStatus === 2 && (
                      <ykc-button type="text" onClick={() => this.handleRetry(row)}>
                        失败重试
                      </ykc-button>
                    )}
                  </div>
                );
              },
            },
          },
        ],
        retryDialogVisible: false,
        confirmLoading: false,
        currentRow: {},
        logDialogVisible: false,
        logClientSn: '',
      };
    },
    computed: {
      searchData() {
        return [
          {
            comName: 'YkcInput',
            key: 'withdrawNo',
            label: '提现记录编码',
            placeholder: '请输入',
          },
          {
            comName: 'YkcDropdown',
            key: 'withdrawType',
            data: this.withdrawTypeOptions,
            label: '提现类型',
            placeholder: '请选择提现类型',
          },
          {
            comName: 'YkcDropdown',
            key: 'operatorId',
            data: this.operatorList,
            label: '收款商户',
            placeholder: '请选择商户',
          },
          {
            comName: 'YkcDropdown',
            key: 'tradeStatus',
            data: this.tradeStatusOptions,
            label: '交易状态',
            placeholder: '请选择',
          },
          {
            comName: 'YkcDatePicker',
            key: 'createdDate',
            label: '创建时间',
            type: 'daterange',
            startPlaceholder: '开始日期',
            endPlaceholder: '结束日期',
          },
        ];
      },
    },
    created() {
      this.queryOperatorList();
      this.searchTableList();
    },
    methods: {
      /** 查询全部类型商户下拉列表 */
      queryOperatorList() {
        withdrawRecord.queryOperatorList().then(res => {
          this.operatorList = (res || []).map(item => ({
            id: item.operatorId,
            name: item.operatorName,
          }));
        });
      },
      searchTableList() {
        const params = {
          withdrawNo: this.searchParams.withdrawNo,
          // 选了商户忽略提现类型条件
          withdrawType: this.searchParams.operatorId ? '' : this.searchParams.withdrawType,
          operatorId: this.searchParams.operatorId,
          tradeStatus: this.searchParams.tradeStatus,
          createdTimeStart:
            (this.searchParams.createdDate && this.searchParams.createdDate[0]) || '',
          createdTimeEnd: (this.searchParams.createdDate && this.searchParams.createdDate[1]) || '',
          current: this.pageInfo.pageIndex,
          size: this.pageInfo.pageSize,
        };
        withdrawRecord.list(params).then(response => {
          this.tableData = (response && response.records) || [];
          this.pageInfo.total = (response && response.total) || 0;
        });
      },
      handleSearchConfirm(form) {
        this.pageInfo.pageIndex = 1;
        Object.assign(this.searchParams, form);
        this.searchTableList();
      },
      handleSearchClean(form) {
        Object.assign(this.searchParams, form);
        this.searchParams.createdDate = [];
      },
      handlePaginationCurrentChange(current) {
        this.pageInfo.pageIndex = current;
        this.searchTableList();
      },
      handlePaginationSizeChange(size) {
        this.pageInfo.pageIndex = 1;
        this.pageInfo.pageSize = size;
        this.searchTableList();
      },
      doExportFile() {
        offlineExport(
          {
            downloadType: 'finance_export',
            jsonNode: {
              downloadKey: 'withdrawRecordExport',
              withdrawNo: this.searchParams.withdrawNo,
              // 选了商户忽略提现类型条件
              withdrawType: this.searchParams.operatorId ? '' : this.searchParams.withdrawType,
              operatorId: this.searchParams.operatorId,
              tradeStatus: this.searchParams.tradeStatus,
              createdTimeStart:
                (this.searchParams.createdDate && this.searchParams.createdDate[0]) || '',
              createdTimeEnd:
                (this.searchParams.createdDate && this.searchParams.createdDate[1]) || '',
            },
          },
          this.pageInfo.total
        );
      },
      /** 查看历史请求日志 */
      handleShowLog(row) {
        this.logClientSn = row.withdrawNo;
        this.logDialogVisible = true;
      },
      handleRetry(row) {
        this.currentRow = row;
        this.confirmLoading = false;
        this.retryDialogVisible = true;
      },
      handleConfirmRetry(hide) {
        this.confirmLoading = true;
        withdrawRecord
          .retryWithdraw(this.currentRow.id)
          .then(() => {
            this.$message.success('重试已提交');
            hide();
            this.searchTableList();
          })
          .finally(() => {
            this.confirmLoading = false;
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
  // 操作列按钮间距
  .operate-btns {
    .ykc-button + .ykc-button {
      margin-left: 16px;
    }
  }

  .record-page {
    padding: 0;
  }

  .request-dialog-content {
    padding: 10px 0;

    .request-item {
      margin-bottom: 16px;
      font-size: 14px;

      .request-label {
        color: #606266;
      }

      .request-value {
        color: #303133;
        font-weight: 500;
      }
    }
  }
</style>
